import { FC } from 'react';
import {
  TableDataGrid,
  TableDataGridProps
} from '../../../../lib/components/compound/tableDataGrid';
import { GridSortModel } from '@mui/x-data-grid-pro';

type Props = TableDataGridProps & {
  hideHeader?: boolean;
  sortModel?: GridSortModel;
};

export const CompanyTable: FC<Props> = ({ hideHeader = false, sortModel = [], ...props }) => {
  return (
    <TableDataGrid
      checkboxSelection={false}
      hideFooter
      headerHeight={hideHeader ? 0 : 56}
      sortModel={sortModel}
      {...props}
    />
  );
};
